import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const CreditCardIcon = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)
  if (!state.locationDesignConfig) return null

  return (
    <svg
      {...props}
      width="156"
      height="114"
      viewBox="0 0 156 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="112.723"
        y="6.75319"
        width="56.3924"
        height="86.3386"
        rx="11.439"
        transform="rotate(45 112.723 6.75319)"
        fill="white"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="3.5"
      />
      <rect
        width="89.8386"
        height="12.8341"
        transform="matrix(0.707108 -0.707106 0.707108 0.707106 73.3984 92.0029)"
        fill={state.locationDesignConfig.baseColors.primary}
      />
      <rect
        x="2.1725"
        y="19.8251"
        width="62.5867"
        height="95.6301"
        rx="11.439"
        transform="rotate(-16.3806 2.1725 19.8251)"
        fill="white"
        stroke={state.locationDesignConfig.baseColors.secondary}
        strokeWidth="3.5"
      />
      <rect
        x="20.3789"
        y="12.6484"
        width="23.6024"
        height="9.44096"
        rx="2.19817"
        transform="rotate(-16.3806 20.3789 12.6484)"
        fill={state.locationDesignConfig.baseColors.secondary}
      />
      <path
        d="M48.2041 90.5723L61.7907 86.5786"
        stroke={state.locationDesignConfig.baseColors.secondary}
        strokeWidth="3.5"
      />
    </svg>
  )
}

export default CreditCardIcon
